import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const EntryHeading = styled.div`
  display: flex;
  position: relative;
  align-items: flex-end;
  justify-content: space-between;
  padding: ${({ main }) => (main ? '9px 9px 0' : '0 0 21px 0')};

  ${({ main, pro }) =>
    (!main && !pro
      ? `
      &:before,
      &:after {
        position: absolute;
        z-index: 2;
        bottom: 0;
        width: 0;
        height: 0;
        content: '';
        border-style: solid;
      }

      &:before {
        left: 14px;
        border-width: 0 10px 10px 10px;
        border-color: transparent transparent #e9ecee transparent;
      }

      &:after {
        left: 15px;
        border-width: 0 9px 9px 9px;
        border-color: transparent transparent #fff transparent;
      }
      `
      : null)};

  ${maxMediaQueries.phablet`
    ${({ main, pro }) =>
    (!main
      ? `
      padding: 0 0 21px 9px;

      &:before {
        left: ${pro ? '1.89rem' : '22px'};
        border-width: ${pro ? '0px 14px 14px 14px' : '0 10px 10px 10px'};
        bottom: ${pro ? '-4px' : 0};
      }

      &:after {
        left: 23px;
        bottom: ${pro ? '-4px' : 0};
      }`
      : null)};
  `};
`;
